<template>
  <el-button @click="download()" style="color: #006aff;border: 1px solid #006aff;" :size="size" :plain="plain">导出</el-button>
</template>
<script>
  import {exportData} from "./excel_module.js"
  export default {
    name: "ExportExcel",
    props: {
      moduleName: String,
      queryParam: Object,
  /*    type: {
        type: String,
        default : "info"
      },*/
      plain: {
        type: Boolean,
        default : false
      },
      size:{
        type:String,
        default: "small"
      }
    },
    data() {
      return {
        currentModule: null,
        moduleArr: [
          {
            module: "inspection_point", name: "巡检点位",
            exportUrl: getBaseUrl() + "/excel/export/inspection_point",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "equ_monitor", name: "监控对象",
            exportUrl: getBaseUrl() + "/excel/export/equ_monitor",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "ent_person_archive", name: "企业人员档案",
            exportUrl: getBaseUrl() + "/excel/export/ent_person_archive",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "ent_person_certificate", name: "企业人员证书档案",
            exportUrl: getBaseUrl() + "/excel/export/ent_person_certificate",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "ent_work_post", name: "工种岗位",
            exportUrl: getBaseUrl() + "/excel/export/ent_work_post",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
            {
                module: "safety_goal", name: "安全目标",
                exportUrl: getBaseUrl() + "/excel/export/safety_goal",
                downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
            },
            {
                module: "safety_produce_duty", name: "安全生产责任",
                exportUrl: getBaseUrl() + "/excel/export/safety_produce_duty",
                downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
            },
          {
            module: "ent_certificate", name: "证书档案",
            exportUrl: getBaseUrl() + "/excel/export/ent_certificate",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "zd_hazard_source", name: "重大危险源",
            exportUrl: getBaseUrl() + "/excel/export/zd_hazard_source",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "zd_hazardous_process", name: "危化工艺信息",
            exportUrl: getBaseUrl() + "/excel/export/zd_hazardous_process",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "zd_chemical", name: "化学品信息",
            exportUrl: getBaseUrl() + "/excel/export/zd_chemical",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "zd_production_device", name: "生产装置信息",
            exportUrl: getBaseUrl() + "/excel/export/zd_production_device",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "zd_leak_point", name: "泄漏点信息",
            exportUrl: getBaseUrl() + "/excel/export/zd_leak_point",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "zd_storage_tank", name: "储罐信息",
            exportUrl: getBaseUrl() + "/excel/export/zd_storage_tank",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "zd_warehouse", name: "仓库信息",
            exportUrl: getBaseUrl() + "/excel/export/zd_warehouse",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "monitor_indicator", name: "监测指标",
            exportUrl: getBaseUrl() + "/excel/export/monitor_indicator",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "monitor_alarm", name: "报警汇总",
            exportUrl: getBaseUrl() + "/excel/export/monitor_alarm",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "video_alarm", name: "报警汇总",
            exportUrl: getBaseUrl() + "/excel/export/video_alarm",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "alarm_statistics", name: "报警统计",
            exportUrl: getBaseUrl() + "/excel/export/alarm_statistics",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "equ_sensor", name: "传感设备",
            exportUrl: getBaseUrl() + "/excel/export/equ_sensor",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "equ_camera", name: "摄像头设备",
            exportUrl: getBaseUrl() + "/excel/export/equ_camera",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "inspection_plan", name: "巡检计划",
            exportUrl: getBaseUrl() + "/excel/export/inspection_plan",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "risk_identify", name: "风险辨识",
            exportUrl: getBaseUrl() + "/excel/export/risk_identify",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "risk_analyse", name: "风险分析对象",
            exportUrl: getBaseUrl() + "/excel/export/risk_analyse",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "risk_control", name: "分级管控",
            exportUrl: getBaseUrl() + "/excel/export/risk_control",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "hid_danger_check_lib", name: "隐患检查库",
            exportUrl: getBaseUrl() + "/excel/export/hid_danger_check_lib",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "hid_danger_checklist", name: "隐患检查表",
            exportUrl: getBaseUrl() + "/excel/export/hid_danger_checklist",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "hid_danger_plan", name: "隐患排查计划",
            exportUrl: getBaseUrl() + "/excel/export/hid_danger_plan",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "hid_danger_fix", name: "隐患整改",
            exportUrl: getBaseUrl() + "/excel/export/hid_danger_fix",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "duty_check_state", name: "包保责任履职情况",
            exportUrl: getBaseUrl() + "/excel/export/duty_check_state",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "hid_fix_integral", name: "排查积分",
            exportUrl: getBaseUrl() + "/excel/export/hid_fix_integral",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "integral_dept_operation", name: "部门运行情况",
            exportUrl: getBaseUrl() + "/excel/export/integral_dept_operation",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "hid_danger_statistic", name: "统计分析",
            exportUrl: getBaseUrl() + "/excel/export/hid_danger_statistic",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "hid_danger_statistic_person", name: "统计分析",
            exportUrl: getBaseUrl() + "/excel/export/hid_danger_statistic_person",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
            {
                module: "hid_danger_yhjb", name: "隐患级别",
                exportUrl: getBaseUrl() + "/excel/export/hid_danger_yhjb",
                downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
            },
            {
                module: "hid_danger_yhlb", name: "隐患类别",
                exportUrl: getBaseUrl() + "/excel/export/hid_danger_yhlb",
                downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
            },
          {
            module: "hid_danger_statistic", name: "统计分析",
            exportUrl: getBaseUrl() + "/excel/export/hid_danger_statistic",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "person_register", name: "外来人员登记",
            exportUrl: getBaseUrl() + "/excel/export/person_register",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "positioning_card", name: "定位卡管理",
            exportUrl: getBaseUrl() + "/excel/export/positioning_card",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "location_alarm_summary", name: "报警汇总",
            exportUrl: getBaseUrl() + "/excel/export/location_alarm_summary",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "floor_manage", name: "楼层管理",
            exportUrl: getBaseUrl() + "/excel/export/floor_manage",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "device_ledger", name: "设备台账",
            exportUrl: getBaseUrl() + "/excel/export/device_ledger",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "emergency_material", name: "应急物资",
            exportUrl: getBaseUrl() + "/excel/export/emergency_material",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "emergency_team", name: "应急队伍",
            exportUrl: getBaseUrl() + "/excel/export/emergency_team",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "emergency_drill", name: "应急演练",
            exportUrl: getBaseUrl() + "/excel/export/emergency_drill",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "health_examination_files", name: "健康体检档案",
            exportUrl: getBaseUrl() + "/excel/export/health_examination_files",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "invite_user", name: "体检人员",
            exportUrl: getBaseUrl() + "/excel/export/invite_user",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "rel_contractor_person", name: "承包商人员管理",
            exportUrl: getBaseUrl() + "/excel/export/rel_contractor_person",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "rel_contractor_person_certificate", name: "承包商人员证书管理",
            exportUrl: getBaseUrl() + "/excel/export/rel_contractor_person_certificate",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "labor_protection", name: "劳保用品管理",
            exportUrl: getBaseUrl() + "/excel/export/labor_protection",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "question_manage", name: "题库管理",
            exportUrl: getEduURL() + "/excel/export/question_manage",
            downloadUrl: getEduURL() + "/excel/download/${fileKey}",
          },
          {
            module: "exam_statistic", name: "考试统计",
            exportUrl: getEduURL() + "/excel/export/exam_statistic",
            downloadUrl: getEduURL() + "/excel/download/${fileKey}",
          },
          {
            module: "out_exam_statistic", name: "考试统计",
            exportUrl: getEduURL() + "/excel/export/out_exam_statistic",
            downloadUrl: getEduURL() + "/excel/download/${fileKey}",
          },
          {
            module: "train_statistic", name: "课程统计",
            exportUrl: getEduURL() + "/excel/export/train_statistic",
            downloadUrl: getEduURL() + "/excel/download/${fileKey}",
          },
          {
            module: "out_train_statistic", name: "课程统计",
            exportUrl: getEduURL() + "/excel/export/out_train_statistic",
            downloadUrl: getEduURL() + "/excel/download/${fileKey}",
          },
          {
            module: "user_manage", name: "用户管理",
            exportUrl: getUssoUrl() + "/excel/export/user_manage",
            downloadUrl: getUssoUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "role_manage", name: "角色管理",
            exportUrl: getUssoUrl() + "/excel/export/role_manage",
            downloadUrl: getUssoUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "menu_manage", name: "菜单管理",
            exportUrl: getUssoUrl() + "/excel/export/menu_manage",
            downloadUrl: getUssoUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "dept_manage", name: "部门管理",
            exportUrl: getUssoUrl() + "/excel/export/dept_manage",
            downloadUrl: getUssoUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "post_manage", name: "岗位管理",
            exportUrl: getUssoUrl() + "/excel/export/post_manage",
            downloadUrl: getUssoUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "work_measure", name: "作业安全措施",
            exportUrl: getBaseUrl() + "/excel/export/work_measure",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },

          {
            module: "work_safety_analysis_measure", name: "JSA安全分析",
            uploadUrl: getBaseUrl() + "/excel/import/work_safety_analysis_measure",
            templateUrl: getBaseUrl() + "/excel/download/${fileKey}"
          },
          {
            module: "work_query", name: "作业查询",
            exportUrl: getBaseUrl() + "/excel/export/work_query",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "work_basic_data", name: "基础数据",
            exportUrl: getBaseUrl() + "/excel/export/work_basic_data",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "hid_danger_fix_query", name: "隐患查询",
            exportUrl: getBaseUrl() + "/excel/export/hid_danger_fix_query",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
            {
                module: "emergency_response", name: "应急处置卡",
                exportUrl: getBaseUrl() + "/excel/export/emergency_response",
                downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
            },
            {
                module: "security_pledge", name: "安全承诺卡",
                exportUrl: getBaseUrl() + "/excel/export/security_pledge",
                downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
            },
            {
                module: "risk_know", name: "风险应知卡",
                exportUrl: getBaseUrl() + "/excel/export/risk_know",
                downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
            },
          {
            module: "law_regulation", name: "法律法规",
            exportUrl: getBaseUrl() + "/excel/export/law_regulation",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
          {
            module: "leader_duty", name: "领导值班管理",
            exportUrl: getBaseUrl() + "/excel/export/leader_duty",
            downloadUrl: getBaseUrl() + "/excel/download/${fileKey}",
          },
        ]
      }
    },
    mounted(){
      for (let data of this.moduleArr) {
        if (this.moduleName === data.module) {
          this.currentModule = data;
        }
      }
    },
    methods: {
      download(){
        let url = this.currentModule.exportUrl;
        exportData(url, this.queryParam).then((res) => {
          let result = res.data;
          let downloadUrl = this.currentModule.downloadUrl.replace('${fileKey}', '');
          window.location.href = downloadUrl + result.downloadKey;
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/excel/ExportExcel.vue